//
// Copyright (c) 2011-2018 by Curalate, Inc.
//


import ClientId from '@models/ClientId';
import ItemId from '@models/ItemId';
import PartialCuid from '@models/PartialCuid';
import { UniversalItemType } from '@models/UniversalItemType';
import { Opaque } from '@utils/opaque';

type Cuid = Opaque<string, 'Cuid'>;

function CuidFactory(cuid: string) {
  return cuid as Cuid;
}

const Cuid = Object.assign(CuidFactory, {
  toPartial(cuid: Cuid) {
    return PartialCuid(cuid.split('.').slice(0, 2).join('.'));
  },
  fromPartial(pCuid: PartialCuid, clientId: ClientId) {
    return CuidFactory(`${pCuid}.${clientId}`);
  },
  build(
    { itemType, id }: { itemType: UniversalItemType; id: ItemId },
    clientId: ClientId,
  ) {
    return CuidFactory(`${itemType}.${id}.${clientId}`);
  },
  buildFromNetworkItem(
    { network, id }: { network: UniversalItemType; id: ItemId },
    clientId: ClientId,
  ) {
    return CuidFactory(`${network}.${id}.${clientId}`);
  },
  parse(cuid: Cuid) {
    const [itemType, itemId, clientId] = cuid.split('.');

    return {
      itemType: itemType as UniversalItemType,
      itemId: itemId as ItemId,
      clientId: ClientId(parseInt(clientId ?? '', 10)),
    };
  },
});

export default Cuid;
